import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getSubscriptionStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      paddingHorizontal: theme.spacing.lg,
      paddingTop: theme.spacing.lg,
    },
    contentContainer: {
      paddingBottom: theme.spacing.xxxl,
      gap: theme.spacing.xl,
    },
    // Hero / intro
    hero: {
      alignItems: 'center',
      gap: theme.spacing.sm,
      paddingVertical: theme.spacing.md,
    },
    heroIntro: {
      color: theme.colors.secondary,
      textAlign: 'center',
      marginTop: theme.spacing.xs,
    },
    // Tiers layout — stacked by default, side by side on wide viewports.
    tiers: {
      gap: theme.spacing.xl,
    },
    tiersRow: {
      flexDirection: 'row',
      alignItems: 'stretch',
    },
    tierColumn: {
      flex: 1,
    },
    // Infinity CTA — gold fill (Button's default fill is primary blue).
    ctaButton: {
      backgroundColor: theme.colors.gold,
      borderWidth: 0,
    },
    // Premium (already-subscribed) state
    premiumCard: {
      borderRadius: theme.border.large,
      borderWidth: 1,
      borderColor: theme.colors.gold,
      backgroundColor: theme.colors.gold + '10',
      padding: theme.spacing.xl,
      alignItems: 'center',
      gap: theme.spacing.sm,
    },
    premiumTitle: {
      color: theme.colors.gold,
      textAlign: 'center',
    },
    premiumSubtitle: {
      color: theme.colors.secondary,
      textAlign: 'center',
    },
    premiumMeta: {
      color: theme.colors.secondary,
      marginTop: theme.spacing.sm,
    },
    // "Gérer mon abonnement" — outlined gold, secondary to the status.
    manageButton: {
      marginTop: theme.spacing.md,
      backgroundColor: 'transparent',
      borderColor: theme.colors.gold,
    },
    // "Arrêter mon abonnement" — red text-style action; it only opens the
    // "are you sure?" confirmation, never stops anything on its own.
    cancelButton: {
      backgroundColor: 'transparent',
      borderWidth: 0,
    },
    // "Restaurer les achats" — subtle text-style action, always available.
    restoreButton: {
      backgroundColor: 'transparent',
      borderWidth: 0,
    },
    // Legal footer (App Store 3.1.2): subscription disclosure + Terms/Privacy.
    legalFooter: {
      alignItems: 'center',
      gap: theme.spacing.sm,
      marginTop: theme.spacing.md,
      paddingHorizontal: theme.spacing.md,
    },
    legalText: {
      color: theme.colors.secondary,
      textAlign: 'center',
    },
    legalLinks: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: theme.spacing.lg,
    },
    legalLink: {
      color: theme.colors.primary,
      textDecorationLine: 'underline',
    },
  })
